module.exports = __webpack_public_path__ + "static/media/total_cholesterol.18b43d1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/misc/assessment/total_cholesterol.png
// module id = 2779
// module chunks = 0